import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { ObjectStoreDetails } from "./components/ObjectStoreDetails";

export function ObjectStorePage() {
  return (
    <LqsPage title="Object Store Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <ObjectStoreDetails />
      </Container>
    </LqsPage>
  );
}
